<template>
  <ItemPage
    title="Sistemas de ensino"
    size="sm"
    :actions="actions"
  >
    <template
      v-if="teachingSystemsView"
    >
      <v-simple-table fixed-header>
        <template v-if="loading">
          <Load :loadingmsg="loadingMsg" />
        </template>
        <div
          v-else
        >
          <v-data-table
            :headers="headers"
            :items="contents"
            :items-per-page="10"
            :search="search"
            item-key="id"
            @click:row="editTeachingSystem($event)"
          />
        </div>
      </v-simple-table>
    </template>
    <template v-else>
      usuário sem permissão
    </template>
  </ItemPage>
</template>

<script>
import Load from '@/components/Loading.vue'
import GenericFormDialog from '@/components/settings/GenericFormDialog.vue'
import utils from '@/api/utils.js'
import ItemPage from '@/components/pages/ItemPage.vue'

export default {
  components: {
    Load,
    ItemPage
  },
  data () {
    return {
      teachingSystemsView: false,
      teachingSystemsCreate: false,
      loading: false,
      loadingMsg: '',
      request: false,
      dialogAddteachingSystem: false,
      contents: [],
      search: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Abreviatura',
          align: 'start',
          value: 'short_name'
        }
      ]
    }
  },
  computed: {
    actions () {
      return [
        {
          label: 'Adicionar sistema de ensino',
          action: this.openGenericFormDialog,
          icon: 'mdi-plus',
          disabled: !this.teachingSystemsCreate
        }
      ]
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.getTeachingSystems()
      this.teachingSystemsView = utils.checkPermissions('teaching-systems.view-any')
      this.teachingSystemsCreate = utils.checkPermissions('teaching-systems.create')
    },
    async getTeachingSystems () {
      this.loading = true
      this.loadingMsg = 'Carregando Lista...'
      try {
        const content = await this.$api.getTeachingSystems()
        this.contents = content
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter sistema de ensino, tente novamente mais tarde.', color: 'red' })
      }
      this.loading = false
    },
    editTeachingSystem (event) {
      this.$router.push({ name: 'sistema-de-ensino.id', params: { id: event.id } })
    },
    openGenericFormDialog () {
      this.$dialog.custom(GenericFormDialog).with({ title: 'Sistema de Ensino' }).show()
        .then((teachingSystem) => {
          if (!teachingSystem) {
            return
          }
          this.newTeachingSystem(teachingSystem)
        })
    },
    async newTeachingSystem (data) {
      if (!data?.short_name) {
        data.short_name = data.name.replaceAll(' ', '-')
      }
      if (!data?.identifier_name) {
        data.identifier_name = data.short_name
      }
      this.loadingMsg = 'Salvando...'
      try {
        await this.$api.newTeachingSystem(data)
        this.$store.dispatch('setSnackBar', { text: 'Salvo com sucesso.' })
        this.fetchAll()
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível salvar, tente novamente mais tarde.', color: 'red' })
      }
      this.request = false
    }
  }
}
</script>
